var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 1.99996H6.99992L5.66658 0.666626H1.66659C0.933252 0.666626 0.333252 1.26663 0.333252 1.99996V9.99996C0.333252 10.7333 0.933252 11.3333 1.66659 11.3333H12.3333C13.0666 11.3333 13.6666 10.7333 13.6666 9.99996V3.33329C13.6666 2.59996 13.0666 1.99996 12.3333 1.99996ZM12.3333 9.99996H1.66659V1.99996H5.11325L6.44659 3.33329H12.3333V9.99996ZM7.71992 7.35996L7.25992 9.33329L8.99992 8.31329L10.7399 9.33329L10.2799 7.35996L11.8133 6.03329L9.79325 5.85996L8.99992 3.99996L8.20658 5.85996L6.18658 6.03329L7.71992 7.35996Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdmIcon);
export default __webpack_public_path__ + "static/media/pdmIcon.cb427964e872683544449a693ddec77c.svg";
export { ForwardRef as ReactComponent };